<template><div class="view">

	<main>

		<div class="page-content">

			<form id="become-a-model-form" action="/become-a-model" method="post" enctype="multipart/form-data">

			<h1 class="h1">Become A Model</h1>

			<div class="tab-btns">
				<div 
					v-for="(tab,tab_i) in tabs" 
					class="tab-btn" :class="{'active':( active_tab == tab.slug )}"
					:key="'fdsd'+tab_i"
					@click="active_tab = tab.slug"
				>
					{{tab.label}}
				</div>					
			</div>
			<br>

			<template v-if="active_tab == 'english'">
				<p>
					Scoop models is always looking for new models. we would therefore very much like to hear from you, if you wish to be considered.
				</p>

				<p>
					If you wish to become a model, you must fulfill the following requirements:<br>				
					&mdash; girls: age 13 - 20, height 172 - 184 cm<br>
					&mdash; boys: age 14 - 25, height 183 - 190 cm
				</p>

				<p>
					To receive a quick response, we will need to see following material, preferably without makeup:<br>				
					&mdash; a portrait photo<br>
					&mdash; a profile photo<br>
					&mdash; a full-body photo, where we clearly can see your figure and legs
				</p>

				<p>
					We will also need following measurements:<br>				
					&mdash; chest<br>
					&mdash; waist<br>
					&mdash; hips<br>
					&mdash; clothing size<br>
					&mdash; shoe size
				</p>

				<p>
					If you are under the age of 18, please bring a parent to the casting.<br>
					We do not conduct castings via skype or other online webcam platforms.
				</p>

				<p>
					Please fill out the chart below with your photos and we will get back to you as soon as possible.
				</p>
			</template>

			<template v-if="active_tab == 'dansk'">
				<p>
					Scoop models leder hele tiden efter nye modeller. Vi vil derfor rigtig gerne modtage henvendelse fra dig hvis du ønsker vi skal tage dig i betragtning.
				</p>	
				<p>
					Hvis du vil være model, skal du opfylde følgende krav:<br>
					&mdash; piger: alder 13-20 år - højde 172-184 cm.<br>
					&mdash; drenge: alder 14-25 - højde 183-190 cm.
				</p>
				<p>
					du skal sende os følgende billedmateriale for at få hurtigt svar:<br>
					&mdash; portrætbillde<br>
					&mdash; profilbillede<br>
					&mdash; helfigurbillede - hvor man kan se din krop og ben<br>
					&mdash; billederne skal helst være uden makeup, så vi kan se din hud.
				</p>
				<p>
					vi skal også bruge dine mål:<br>
					&mdash; bryst<br>
					&mdash; talje<br>
					&mdash; hofter (på det bredeste sted)<br>
					&mdash; tøjstørrelse<br>
					&mdash; Skostørrelse<br>
				</p>

				<p>
					Udfyld skemaet og send det med billeder, så vender vi tilbage til dig. Hvis du er under 18 skal du medbringe en forældre til castingen. 
					Vi skal gøre opmærksom på at vi ikke caster via skype, facetime eller andre webcam muligheder.
				</p>
			</template>


			<br><br>

			
			<div class="cols cols-3 mobile-cols-1 cols-midlined">

				<div v-for=" (field,field_key,field_i) in fields " :key="'fakdh'+field_i">

					<div class="field" v-if="field.type == 'text'">
						<label>{{fieldLabel(field)}}</label>
						<input type="text" :name="field_key" v-model="field.value" :data-placeholder="fieldLabel(field)">						
					</div>

					<div class="field" v-if="field.type == 'textarea'">
						<label>{{fieldLabel(field)}}</label>
						<textarea cols="30" rows="10" :name="field_key" v-model="field.value" :data-placeholder="fieldLabel(field)"></textarea>						
					</div>

					<div class="field" v-if="field.type == 'file'">
						<label>{{fieldLabel(field)}} (JPG/PNG)</label>
						<input type="file" :name="field_key" :ref="field_key" @change="uploadImage($event,field_key)" :data-placeholder="fieldLabel(field)">
						<div class="img-reset" @click="resetImg(field_key)">Reset</div>
					</div>

				</div>

			</div>

			<div class="btn btn-outline" @click="send()">Send</div>
			
			</form>
		
		</div>
			
	</main>

</div></template>
<script>
import helpers from '.././helpers.js'
import mixins from '.././mixins.js'
import axios from 'axios'

export default {
	
	mixins: [ mixins.generic ],
	
	components: { 		
		
	},

	data(){ return {
			
		fields: {
			full_name: { type:'text', label:'Full name', label_dk:'Fuldt navn', value:'' },
			email: { type:'text', label:'Email', label_dk:'Email', value:'' },
			city: { type:'text', label:'City', label_dk:'By', value:'' },
			phone: { type:'text', label:'Phone', label_dk:'Telefon', value:'' },
			age: { type:'text', label:'Age', label_dk:'Alder', value:'' },
			height: { type:'text', label:'Height', label_dk:'Højde', value:'' },
			hair_color: { type:'text', label:'Hair color', label_dk:'Hårfarve', value:'' },
			eye_color: { type:'text', label:'Eye color', label_dk:'Øjenfarve', value:'' },
			dress_size: { type:'text', label:'Size', label_dk:'Tøj str.', value:'' },
			shoe_size: { type:'text', label:'Shoe size', label_dk:'Sko str.', value:'' },
			hips: { type:'text', label:'Hips size (cm)', label_dk:'Hoftemål', value:'' },
			waist: { type:'text', label:'Waist size (cm)', label_dk:'Taljemål', value:'' },
			bust: { type:'text', label:'Bust size (cm)', label_dk:'Brystmål', value:'' },
			best_call_time: { type:'text', label:'Best call time', label_dk:'Bedste opkalds-tid', value:'' },
			comment: { type:'textarea', label:'Comment', label_dk:'Kommentar', value:'' },
			photo_portrait: { type:'file', label:'Portrait photo', label_dk:'Portrætfoto', value:'' },
			photo_full_figure: { type:'file', label:'Full figure photo', label_dk:'Fuld-figur foto', value:'' },
			photo_additional: { type:'file', label:'Additional photo', label_dk:'Yderligere foto', value:'' },
		},

		folderkey: helpers.generate_uid_key(5),

		tabs: [
			{ label:'Dansk', slug:'dansk' },			
			{ label:'English', slug:'english' },
		],

		active_tab: 'dansk',

		img_uploaded: {
			photo_portrait: false,
			photo_full_figure: false,
			photo_additional: false,
		},

	}},

	computed: {

		

	},

	methods: {


		resetImg(field_key){
			this.img_uploaded[field_key] = false
			this.$refs[field_key][0].value = ''
		},

		uploadImage(e, field_key){

			let img = e.target.files[0]

			let formData = new FormData()			
			formData.append( 'image', img )

			formData.append( 'folderkey', this.folderkey )
			formData.append( 'field_key', field_key )

			this.set_big_spinner(true)

			var _this = this

			axios.post( this.$store.state.api_url + 'become_a_model_upload_img', formData, {
				onUploadProgress: progressEvent => {

					var pct = (progressEvent.loaded / progressEvent.total)

					if( pct >= 1 ) {
						//_this.set_big_spinner(false)
						//_this.triggerIconSignal('check')
						//_this.img_uploaded[field_key] = true						
					}

				},
				
			})
			.then(function (response) {
				var output = response.data
				if( output.status != 'success' || output.error ) {
					_this.msg('Error - ' + helpers.unslugify(output.error))
					_this.set_big_spinner(false)
					_this.img_uploaded[field_key] = false
					_this.$refs[field_key][0].value = ''
					return false
				}

				_this.set_big_spinner(false)
				_this.triggerIconSignal('check')
				_this.img_uploaded[field_key] = true
			})
			.catch( ( error,b,c ) => {
				//console.log(error.response.status)
				var http_rcode = error.response.status
				
				switch( http_rcode ) {
					case 400: 
						var msg = 'Error - Could not upload image.<br>Please make sure the image is a valid JPG/PNG<br> file and not exceeding 2 MB in file size.'
					break;
					case 413: 
						var msg = 'Error - The uploaded image is too large.<br>Please make sure the image is a valid JPG/PNG<br> file and not exceeding 2 MB in file size.'
					break;
					case 415: 
						var msg = 'Error - The uploaded image is not in the correct format.<br>Please make sure the image is a valid JPG/PNG<br> file and not exceeding 2 MB in file size.'
					break;
					case 500: 
						var msg = 'Error - Could not upload image.<br>Please make sure the image is a valid JPG/PNG<br> file and not exceeding 2 MB in file size.'
					break;
					default: 
						var msg = 'Error - Could not upload image.<br>Please make sure the image is a valid JPG/PNG<br> file and not exceeding 2 MB in file size.'
					break;
				}

				_this.msg(msg)
				_this.img_uploaded[field_key] = false
				_this.$refs[field_key][0].value = ''
				//console.log('img not ok')
				//console.log(error)
			})

			//this.fields[ field_key ].value = img

		},


		send(){
			
			var _this = this

			if( !this.validateEmail(this.fields.email.value) ) {
				this.msg('Please supply a valid email')
				return
			}

			var valid = true
			
			for( let key in this.fields ) {
				let field = this.fields[key]
				if( !field ) continue			
				if( !valid ) continue

				let field_valid = ( field.value && field.value.length ) 
				if( field.type == 'file' ) field_valid = this.img_uploaded[key]
				console.log('field_valid',key, field_valid, field.type)

				if( !field_valid ) {
					valid = false
					if( this.active_tab == 'english' ) {
						this.msg('Missing info: '+field.label)
					} else {
						this.msg('Manglende info: '+field.label_dk)
					}					
				}

			}

			if( !valid ) return

			let input = {}			
			for( var key in this.fields ) {
				input[key] = this.fields[key].value
			}

			input.folderkey = this.folderkey

			
			this.set_big_spinner(true)


			this.fetch('send_become_a_model_mail', input, {
				onSuccess(output){
					_this.set_big_spinner(false)
					_this.msg('Thank you')
				},
				onError(error){
					_this.msg('Error')
				},
			})


		},


		validateEmail(email) {
			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			return re.test(String(email).toLowerCase())
		},

		fieldLabel(field){
			if( this.active_tab == 'dansk' ) return field.label_dk
			return field.label
		}

	},

	mounted(){
		//this.load_page()
	},

}
</script>



// WEBPACK FOOTER //
// src/views/BecomeModel.vue